/* eslint-disable @typescript-eslint/no-explicit-any*/
import { NOTIFICATION_REPORT } from '~/actions/actionTypes';

const initialState: reducers.NotificationReducer = {
  list: [],
  listCount: 0,
  loading: false,
};

const notificationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case NOTIFICATION_REPORT:
      state = {
        ...state,
        list: action.payload.rows,
        listCount: action.payload.count,
      };
      break;

    default:
      return state;
  }

  return state;
};

export default notificationReducer;
